module.exports = __webpack_public_path__ + "static/media/map-figure-7-4.b3d7dc54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/m/map-figure-7-4.svg
// module id = 676
// module chunks = 0